import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function Proof() {
  return <section className="py-20 px-6 bg-white" data-id="element-122">
      <div className="max-w-4xl mx-auto" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-brand-blueLight to-white p-8 md:p-12 rounded-3xl border border-brand-blue/20 shadow-soft relative overflow-hidden" data-id="element-124">
          <div className="absolute top-0 right-0 p-8 opacity-10" data-id="element-125">
            <Clock className="w-32 h-32 text-brand-blue" data-id="element-126" />
          </div>

          <div className="relative z-10" data-id="element-127">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-brand-blue mb-6" data-id="element-128">
              Resultados en <span className="text-brand-brown" data-id="element-129">72 horas</span>
            </h2>
            <p className="text-lg md:text-xl text-brand-text leading-relaxed font-medium" data-id="element-130">
              En solo 72 horas aplicando el Anclaje Sensorial, el sistema
              nervioso del bebé se regula. No solo se duerme más rápido, sino
              que la calidad de su sueño profundo aumenta, reduciendo los
              micro-despertares innecesarios por causas ambientales.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}